import { Component, OnInit, ViewChild, Injector } from '@angular/core';
import { Router } from '@angular/router';

import { Observable } from 'rxjs';

import { MenuService } from '../../core/menu/menu.service';
import { LoginService } from '../../core/service/login.service';
import { SettingsService } from '../../core/settings/settings.service';

const screenfull = require('screenfull');

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})

export class HeaderComponent implements OnInit {

    navCollapsed = true; // for horizontal layout
    router: Router;
    angle = 0;

    @ViewChild('fsbutton', { static: true }) private fsbutton;
    @ViewChild('sbbutton') private sbbutton;

    constructor(
        public menu: MenuService,
        private login: LoginService,
        public injector: Injector,
        public settings: SettingsService) {

    }

    ngOnInit() {
        this.onInit();
    }
    isCollapsedText() {
        return this.settings.getLayoutSetting('isCollapsedText');
    }
    onInit() {
        this.onInitFullScreen();
        this.onInitRouter();
    }
    onInitRouter() {
        this.router = this.injector.get(Router);
        // autoclose navbar on mobile when route change
        this.router.events.subscribe((val) => {
            // scroll view to top
            window.scrollTo(0, 0);
            // close collapse menu
            this.navCollapsed = true;
        });
    }
    logout() {
        this.login.logout(true);
    }
    //screen
    onInitFullScreen() {
        var e = this.fsbutton.nativeElement;

        if (this.isNone) {
            e.style.display = 'none';
        }
        else {
            const c = e.firstElementChild;

            screenfull.on('change',
                () => {
                    if (c) {
                        let fa = 'fa fa-';

                        c.className = fa + (screenfull.isFullscreen ? 'compress' : 'expand');
                    }
                });
        }
    }
    toggleFullScreen(event) {
        if (screenfull.enabled) {
            screenfull.toggle();
        }
    }
    //sidebar
    toggleCollapsedSideabar() {
        var e = this.sbbutton.nativeElement;
        var c = e.firstElementChild;

        if (c) {
            c.style.transform = this.rotate;
            this.settings.toggleLayoutSetting('isCollapsed');
        }
    }
    //is
    get isNone(): boolean {
        var a: string = window.navigator.userAgent;
        let ok: boolean = a.indexOf("MSIE ") > 0;

        if (!ok) {
            ok = !!a.match(/Trident.*rv\:11\./);
        }

        return ok;
    }
    //other
    get rotate(): string {
        this.angle = this.angle > 0 ? 0 : 180;

        return 'rotate(' + this.angle + 'deg)';
    }

}
